import AppButton from 'src/components/base/Button/Button';
import './TrackVerficationStatusTodo.scss';
import React, { useState } from 'react';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { useDispatch } from 'react-redux';
import { updateIfollowedUpTodo } from 'src/redux/services/loggingServices';
import { Logger } from 'src/latest/src/services/ConsoleLogger';
import { changeTodoStatusV1 } from '../../../../../api/user';
import { TodoTypeEnums } from 'src/latest/src/constants';
import DatePicker from 'src/latest/src/components/common/DatePicker/DatePicker';
import { useTranslation } from 'react-i18next';

interface Props {
  todo: any;
  onConfirm: () => void;
}

const TrackVerificationStatusTodo: React.FC<Props> = ({ onConfirm, todo }) => {
  const [loadingYes, setLoadingYes] = useState(false);
  const [loadingNo, setLoadingNo] = useState(false);

  const [loadingPendingToDo, setLoadingPendingToDo] = useState(false);
  const [expiryDate, setExpiryDate] = useState('');
  const [hasDateError, setHasDateError] = useState(false);
  const { t } = useTranslation('components');

  const minExpiryDate = new Date();

  minExpiryDate.setHours(0, 0, 0, 0);

  const dispatch = useDispatch();

  const createFollowUp = async (status: boolean) => {
    const respObj = {
      follow_up_by: [TodoTypeEnums.SELF],
      is_valid_license: status,
      license_expiration_date: expiryDate,
      note: ``,
    };

    try {
      if (status) setLoadingYes(true);
      else setLoadingNo(true);
      await updateIfollowedUpTodo(todo.id, respObj);
      dispatch(clearModalContent());
      onConfirm();
    } catch (e) {
      Logger.error('Follow up error', e);
    } finally {
      if (status) setLoadingYes(false);
      else setLoadingNo(false);
    }
  };

  const markToDoAsPending = async () => {
    const note = '';

    setLoadingPendingToDo(true);

    try {
      await changeTodoStatusV1(todo.id, false, note);
      onConfirm();

      dispatch(clearModalContent());
    } catch (e) {
      Logger.log(e);
    }

    setLoadingPendingToDo(false);
  };

  return (
    <div className="track-verification-status-todo-container">
      <div>
        <b>{todo?.user_full_name}</b>{' '}
        {t('TrackVerificationStatusTodo.providerDescription')}
      </div>
      <div className="mt-1">
        {t('TrackVerificationStatusTodo.licenseType')}{' '}
        {todo?.metadata.LICENSED_TYPE}
      </div>
      <div className="mt-1">
        {t('TrackVerificationStatusTodo.licenseNumber')}{' '}
        {todo?.metadata.LICENSE_NUMBER}{' '}
      </div>
      <div className="mt-1">
        {t('TrackVerificationStatusTodo.licenseState')}{' '}
        {todo?.metadata.LICENSED_STATE}
      </div>
      <div className="mt-1">
        {' '}
        <DatePicker
          title="Enter Licence Expiration Date:"
          placeholder="MM/DD/YYYY"
          inputValue={expiryDate}
          onChange={(val: string) => setExpiryDate(val)}
          required={true}
          requiredMessage={t('TrackVerificationStatusTodo.requiredMessage')}
          invalidMessage={t('TrackVerificationStatusTodo.invalidMessage')}
          minDate={minExpiryDate}
          maxDate={new Date(2100, 11, 31)}
          mode="date"
          onErrorChange={setHasDateError}
        />
      </div>
      <div className="mt-4">{t('TrackVerificationStatusTodo.description')}</div>
      <div className="d-flex justify-content-center mt-4">
        <div>
          <AppButton
            label={t('TrackVerificationStatusTodo.Yes')}
            textWeight="bold"
            textSize="size-14"
            isProcessing={loadingYes}
            disabled={expiryDate === '' || hasDateError}
            className="m-3 todo-button"
            onClick={() => {
              createFollowUp(true);
            }}
          />
        </div>
        <div>
          <AppButton
            label={t('TrackVerificationStatusTodo.No')}
            textWeight="bold"
            textSize="size-14"
            variant="light"
            isProcessing={loadingNo}
            disabled={expiryDate === '' || hasDateError}
            className="m-3 todo-button bg-white"
            onClick={() => {
              createFollowUp(false);
            }}
          />
        </div>
      </div>
      <AppButton
        onClick={markToDoAsPending}
        className="mt-4 bg-white"
        variant="light"
        disabled={
          loadingPendingToDo ||
          loadingYes ||
          loadingNo ||
          todo.active === false
        }
        isProcessing={loadingPendingToDo}
        label={t('TrackVerificationStatusTodo.markToDoAsPending')}
      />
    </div>
  );
};

export default TrackVerificationStatusTodo;
